import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "sonner";
import "lenis/dist/lenis.css";

/* Centralised scroll handling for Lenis: top on route change, smooth to hash anchors */
function ScrollManager() {
  const { pathname, hash } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const t = setTimeout(() => lenis?.scrollTo(el, { offset: -96, duration: 1.4 }), 80);
        return () => clearTimeout(t);
      }
    }
    lenis?.scrollTo(0, { immediate: true });
  }, [pathname, hash, lenis]);

  return null;
}

export default function Layout({ children }) {
  return (
    <MotionConfig reducedMotion="user">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <div className="min-h-screen bg-[#050A14] text-white">
          <ScrollManager />
          <Header />
          <main className="pt-24">{children}</main>
          <Footer />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0F1626",
                border: "1px solid rgba(255,255,255,0.08)",
                color: "#F8FAFC",
              },
            }}
          />
        </div>
      </ReactLenis>
    </MotionConfig>
  );
}
